import { useMemo, useState } from 'react'
import { Card } from './CardComponent'
import { LineChart, BarChart } from 'react-native-gifted-charts'
import { View, Text } from 'react-native'
import theme from '../../../theme'

export const LineChartCardChat = ({ title, value, data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    return (
        <Card
            style={{
                overflow: 'hidden',
                shadowOpacity: 0,
                shadowRadius: 0,
                elevation: 0,
            }}
            setCardWidth={(w) => setCardWidth(w)}
        >
            <View
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 24,
                    width: '100%',
                }}
            >
                <Text
                    style={{
                        fontSize: 16,
                        lineHeight: 24,
                        fontWeight: '600',
                        maxWidth: '70%',
                        color: theme.colors.textPrimary,
                    }}
                >
                    {title}
                </Text>
                <Text
                    style={{
                        fontSize: 18,
                        lineHeight: 24,
                        fontWeight: '700',
                        color: theme.colors.textPrimary,
                    }}
                >
                    {value}
                </Text>
            </View>

            {/* Chart */}
            <View style={{ width: cardWidth, overflow: 'hidden' }}>
                <LineChart
                    width={cardWidth}
                    data={data}
                    curved
                    thickness={3}
                    hideRules
                    hideDataPoints
                    initialSpacing={0}
                    color='#6366f1'
                    startFillColor='#6366f1'
                    endFillColor='#6366f111'
                    startOpacity={0.25}
                    endOpacity={0.05}
                    yAxisThickness={0}
                    noOfSections={3}
                    animateOnDataChange
                    animationDuration={700}
                    spacing={cardWidth / data.length}
                    areaChart
                    pointerConfig={{
                        pointerStripHeight: 120,
                        pointerStripColor: '#6366f166',
                        radius: 6,
                        pointerColor: '#6366f1',
                    }}
                    disablePress
                />
            </View>
        </Card>
    )
}
export const SimpleDataBarChartCardChat = ({ title, data, styles }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth
    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text
                style={{
                    fontSize: 16,
                    lineHeight: 24,
                    fontWeight: '600',
                    marginBottom: 24,
                    color: theme.colors.textPrimary,
                }}
            >
                {title}
            </Text>

            <BarChart
                width={BarWidth}
                data={data}
                barWidth={36}
                spacing={12}
                barBorderRadius={0}
                initialSpacing={20}
                yAxisThickness={0}
                xAxisThickness={0}
                noOfSections={4}
                hideRules
                frontColor='#4E8EF5'
                yAxisLabelContainerStyle={{ width: 40 }}
                yAxisTextStyle={{ color: '#777' }}
                xAxisLabelTextStyle={{
                    color: '#555',
                    fontWeight: '600',
                    fontSize: 12,
                }}
                disablePress
                barBorderTopRightRadius={20}
                barBorderTopLeftRadius={20}
                barBorderBottomLeftRadius={20}
                barBorderBottomRightRadius={20}
            />
        </Card>
    )
}

export const ComparisonBarChartChat = ({ styles, title = '', data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth
    // Convertimos en estructura compatible (2 barras por mes)
    const chartData = data.flatMap((item) => {
        return [
            {
                value: item.a,
                frontColor: '#6A5AE0',
                // barWidth: 30,
                spacing: 2, // espacio interno del grupo
                label: '', // solo la PRIMER barra muestra label
            },
            {
                value: item.b,
                frontColor: '#4E8EF5',
                // barWidth: 30,
                spacing: 22, // espacio grande para separar al siguiente grupo
                label: '', // segunda barra del grupo no repite label
                labelComponent: () => (
                    <View
                        style={{
                            position: 'absolute',
                            top: 5, // ajustá a gusto
                            left: -22, // 🔥 offset para centrar entre barra A y B
                            width: 60,
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            style={{
                                color: '#555',
                                fontWeight: '600',
                                fontSize: 12,
                            }}
                        >
                            {item.label}
                        </Text>
                    </View>
                ),
            },
        ]
    })

    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text
                style={{
                    fontSize: 16,
                    lineHeight: 24,
                    fontWeight: '600',
                    marginBottom: 24,
                    color: theme.colors.textPrimary,
                }}
            >
                {title}
            </Text>

            <BarChart
                width={BarWidth}
                data={chartData}
                adjustToWidth
                barWidth={35}
                barBorderRadius={0}
                yAxisThickness={0}
                xAxisThickness={1}
                xAxisColor='#ccc'
                noOfSections={4}
                maxValue={1000}
                spacing={7}
                hideRules
                yAxisTextStyle={{ color: '#777' }}
                yAxisLabelContainerStyle={{ width: 40 }}
                xAxisLabelTextStyle={{ color: '#555', fontWeight: '600' }}
                disablePress
                barBorderTopRightRadius={20}
                barBorderTopLeftRadius={20}
                barBorderBottomLeftRadius={20}
                barBorderBottomRightRadius={20}
            />
        </Card>
    )
}
export const VerticalStackedBarsChat = ({ styles, title = '', data = [] }) => {
    const [cardWidth, setCardWidth] = useState(150)
    const YAxisTextWidth = 40
    const BarWidth = cardWidth - YAxisTextWidth

    //Mapeo para agregar componente label custom
    const mapData = data.map((item, index) => {
        // Clonar los stacks de la barra
        const stacks = [...item.stacks]
        const topIndex = stacks.length - 1
        if (stacks.length > 0) {
            // El primer elemento es el top de la barra stackeada
            stacks[topIndex] = {
                ...stacks[topIndex],
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
            }
            stacks[0] = {
                ...stacks[0],
                borderBottomLeftRadius: 20,
                borderBottomRightRadius: 20,
            }
        }

        return {
            ...item,
            stacks, // reemplazamos por stacks con borde en el top
            labelComponent: () => (
                <View
                    style={{
                        left: -10,
                        alignItems: 'center',
                    }}
                >
                    <Text style={{ color: '#555', fontWeight: '600', fontSize: 12 }}>
                        {item.label}
                    </Text>
                </View>
            ),
        }
    })
    return (
        <Card style={styles} setCardWidth={(w) => setCardWidth(w)}>
            <Text
                style={{
                    fontSize: 16,
                    lineHeight: 24,
                    fontWeight: '600',
                    marginBottom: 24,
                    color: theme.colors.textPrimary,
                }}
            >
                {title}
            </Text>

            <BarChart
                width={BarWidth}
                noOfSections={4}
                stackData={mapData}
                barWidth={40}
                adjustToWidth
                hideRules
                barStyle={{
                    borderRadius: 20,
                    overflow: 'hidden',
                    background: 'red',
                }}
                roundedTop={true}
                roundedBottom={true}
                yAxisThickness={0}
                xAxisThickness={0}
                disablePress
                yAxisTextStyle={{ color: '#777' }}
                xAxisLabelTextStyle={{ color: '#555', fontWeight: '600' }}
            />
            {/* <View style={{ height: 35 }} /> */}
        </Card>
    )
}
